import React from 'react';
import store from '../store';
import FloatButton from '../components/FloatButton';
//import CardContent from '../components/CardContent';
import Toolbar from '../components/Toolbar';
import DialogCourse from '../components/DialogCourse';
import CardChallenge from '../components/CardChallenge';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import  FormControl  from '@material-ui/core/FormControl';
import Button  from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import Grid from '@material-ui/core/Grid';
import GroupWorkIcon from '@material-ui/icons/Group';
import ReceiptIcon from '@material-ui/icons/Receipt';
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";
import StarsIcon from '@material-ui/icons/Stars';
import { FIREBASE } from "../config/firebase";
import Divider from '@material-ui/core/Divider';
import { Redirect } from 'react-router-dom';
import AllInboxIcon from '@material-ui/icons/AllInbox';
import AddIcon from '@material-ui/icons/Add';
const DWIDTH = 640;
if (!firebase.apps.length) {
  firebase.initializeApp(FIREBASE);
}
const styles = theme => ({
    title: {
        marginBottom: theme.spacing.unit * 2,
        padding: 0
    },
    search: {
        backgroundColor: '#fff',
        padding: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 2,
        borderRight: 'solid 1px #ededed',
        borderLeft: 'solid 1px #ededed',
        borderTop: 'solid 1px #ededed'
    },
    buttonAdd: {
        margin: theme.spacing.unit,
        position: 'fixed',
        bottom: theme.spacing.unit * 2,
        right: theme.spacing.unit * 2,
    },
});

function a(q, f) {
    try {
        if (q.toLowerCase().includes(f)) {
            return true;
        } else {
            return false;
        }
    } catch (e) {
        return false;
    }
}


class AdminChallenges extends React.Component {
    constructor() {
        super();
        this.state = { search: '',contents:[],open:false,practice:false};

    }

    loadChallenge(){

      let _this = this;
      firebase.firestore().collection('challenges').doc('challenge').get().then((doc)=>{

        let challenge = doc.data();

        _this.setState({challenge});
      })
    }
    componentDidMount(){
      //this.loadContents();
      this.loadChallenge();
    }
    componentWillUnmount(){
      if(this.state.sub)
      this.state.sub();
    }
    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };
    handleClose = value => {
        this.setState({ open: false });
    };
    handleClickOpen = () => {
            this.setState({
                open: true,
            });
        };



    render() {
        const { classes } = this.props;
        const { search,contents } = this.state;

        const item_button =  { name:"", startDate: '',endDate:'',week:4,course_id:0,created:(new Date()).getTime() };
        if(!store.getState().ADMINACCOUNT)
        {
          console.log('No Admin');
          return <Redirect to='/sbadmin' />
        }
        return (
          <div>
          <Toolbar/>
            <div style={{ maxWidth: '720px',margin: '20px auto',paddingTop: '64px'}}>
                <Grid justify="flex-start" direction="row" container>
                    <Grid item><StarsIcon style={{ marginRight: 10 }} /></Grid>
                    <Grid item><Typography variant="title" className={classes.title}>Challenge</Typography></Grid>
                </Grid>
                {this.state.challenge?
                    <CardChallenge item={this.state.challenge} reload={()=>this.loadChallenge()} />
                :false}


                <FormControl style={{ marginBottom: 30 }} fullWidth>
                    <Input
                        value={this.state.search}
                        onChange={this.handleChange('search')}
                        type="text"
                        placeholder="Search a course"
                        className={classes.search}
                    />
                </FormControl>

                <div style={{ height: 100, display: 'block' }} />

                </div>

            </div>
        )
    }
}

AdminChallenges.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AdminChallenges);
